import React from 'react';
import { HStack, Select, Input } from '@chakra-ui/react';

const PRESETS = [
  { key: 'today', label: 'Today' },
  { key: 'yesterday', label: 'Yesterday' },
  { key: 'last7days', label: 'Last 7 days' },
  { key: 'last30days', label: 'Last 30 days' },
  { key: 'thisWeek', label: 'This week' },
  { key: 'thisMonth', label: 'This month' },
  { key: 'lastMonth', label: 'Last month' },
  { key: 'custom', label: 'Custom' },
];

export default function DateRangePicker({ preset, onPresetChange, start, end, onStartChange, onEndChange }) {
  return (
    <HStack spacing={2}>
      <Select value={preset} onChange={e => onPresetChange?.(e.target.value)} maxW="180px" variant="filled" borderRadius="full">
        {PRESETS.map(p => <option key={p.key} value={p.key}>{p.label}</option>)}
      </Select>
      <Input type="date" value={start} onChange={e => onStartChange?.(e.target.value)} variant="filled" borderRadius="full" maxW="170px" />
      <Input type="date" value={end} onChange={e => onEndChange?.(e.target.value)} variant="filled" borderRadius="full" maxW="170px" />
    </HStack>
  );
}


